import React, { createContext, useContext, useState, ReactNode, useEffect} from 'react';

type ChatContextProps = {
  isChatOpen: boolean;
  openChat: () => void;
  closeChat: () => void;
  toggleChat: () => void;

  activeConversation: any;
  setActiveConversation: React.Dispatch<React.SetStateAction<any>>;
};

const ChatContext = createContext<ChatContextProps>(
  {} as ChatContextProps
);
const CHAT_OPEN_KEY = '@chat:open';


export const ChatProvider = ({ children }: { children: ReactNode }) => {
 const initialConversation = {
    id: crypto.randomUUID(),
    title: 'Nova conversa',
    sourceId: crypto.randomUUID(),
    isTemp: true,
  };

  // Estado inicial
  const [activeConversation, setActiveConversation] = useState(initialConversation);
  const [isChatOpen, setIsChatOpen] = useState(() => {
    return sessionStorage.getItem(CHAT_OPEN_KEY) === 'true';
  });

  // Abre o chat
  const openChat = () => {
    if (isChatOpen) return;
    sessionStorage.setItem(CHAT_OPEN_KEY, 'true');
    window.history.pushState({ chat: true }, '');
    setIsChatOpen(true);
  };

  // Fecha o chat
  const closeChat = () => {
    if (!isChatOpen) return;
    setIsChatOpen(false);
    sessionStorage.removeItem(CHAT_OPEN_KEY);
    if (window.history.state?.chat) window.history.back();
  };

  // Mantém chat aberto após refresh (sincroniza com sessionStorage)
  useEffect(() => {
    if (sessionStorage.getItem(CHAT_OPEN_KEY) === 'true') {
      setIsChatOpen(true);

      // Garante que sempre abra com nova conversa
      setActiveConversation({
        id: crypto.randomUUID(),
        title: 'Nova conversa',
        sourceId: crypto.randomUUID(),
        isTemp: true,
      });
    }
  }, []);

  // Escuta botão voltar do navegador
  useEffect(() => {
    const onPopState = () => {
      setIsChatOpen(false);
      setActiveConversation(null);
      sessionStorage.removeItem(CHAT_OPEN_KEY);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  return (
    <ChatContext.Provider
      value={{
        isChatOpen,
        openChat,
        closeChat,
        toggleChat: () => (isChatOpen ? closeChat() : openChat()),
        activeConversation,
        setActiveConversation,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
export const useChat = () => useContext(ChatContext);
